import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

const Request = ({ isAuthenticated }) => {
  const { t } = useTranslation();

  const handleButtonClick = () => {
    if (isAuthenticated) {
      window.location.href = '/dashboard';
    } else {
      window.location.href = '/login';
    }
  };

  return (
    <>
      <section className="py-2">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <article className="card">
                <div>
                  <h3 className="mb-1 text-center">{t('Online Sick Note Service')}</h3>
                  <div className="bottom-line"></div>
                  <h4 className="mb-2 text-center">{t('Request a Sick Note Online – Fast, Secure, and Doctor-Issued')}</h4>

                  <p className="my-3 text-center">
                    {t(
                      'Need a sick note for work or school absence? Richmond In-Store Medical Clinic offers a fast and secure online sick note service. Submit your request in minutes and receive a doctor-issued note—often within 1 business day.'
                    )}
                  </p>

                  <p className="my-3 text-center">
                    {t("This service is trusted by patients across British Columbia. Your information is protected under BC's PIPA (Personal Information Protection Act).")}
                  </p>

                  <p className="mt-3 text-center">
                    <span className="important-text">{t('Please note:')}</span>{' '}
                    {t('A minimum fee of $65 applies. In some cases, the patient may need to be contacted by phone or seen in person or virtually before the note can be completed.')}
                  </p>

                  <div className="mt-4 center">
                    <p className="mb-4">
                      {t('Request your sick note now – fast, secure, and fully compliant.')}
                      <br />
                      {t('Doctor-reviewed and accepted by most employers and schools.')}
                    </p>
                    <button onClick={handleButtonClick} className="btn btn-uni">
                      {t('Get My Sick Note')}
                    </button>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps)(Request);
